module.exports = __webpack_public_path__ + "static/x59-61d4cf5196a7a97faf17ba06aba3cc32.png";